import { render, staticRenderFns } from "./BillFaxComponent.vue?vue&type=template&id=c26edbc8&scoped=true"
import script from "./BillFaxComponent.vue?vue&type=script&lang=js"
export * from "./BillFaxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26edbc8",
  null
  
)

export default component.exports